import { useImportIcon } from "@utils/hooks";

const tenant = window.TENANT;

const useController = ({ containers, user }) => {
	const [footerImgWebp] = window.FOOTER_HAS_INLINE_IMAGE
		? useImportIcon(tenant, import(`../../assets/backgrounds/${tenant}_footer.webp`))
		: [null];

	const [footerImgSvg] = window.FOOTER_HAS_INLINE_IMAGE
		? useImportIcon(tenant, import(`../../assets/backgrounds/${tenant}_footer.svg`))
		: [null];

	const [footerLogoImgSvg] = window.FOOTER_HAS_INLINE_IMAGE
		? useImportIcon(tenant, import(`../../assets/backgrounds/${tenant}_footer_logo.svg`))
		: [null];

	const filterContainersByUser = (containers, user) => {
		let list = containers || [];
		if (window.TENANT === "betto") {
			list = list.filter((c) => c?.configs?.showInLobby !== false);
		}
		if (!user) {
			return list.filter((container) => {
				if (!container.topic) return true;

				const topics = Object.values(container.topic);
				return !topics.some((topic) => topic.includes("{user}"));
			});
		}

		return list;
	};

	return {
		state: {
			footerImgWebp,
			footerImgSvg,
			footerLogoImgSvg,
			sortedContainer: filterContainersByUser(containers, user),
		},
	};
};

export default useController;
